<template>
  <Layout>
    <template v-slot:default>
      <div class="q-pa-xl centered-container-small">
        <div class="col-12">
          <span class="text-h4">{{ $page.props.i18n.title }}</span>
        </div>

        <div class="col-12 q-pt-xl">
          <div
            v-for="subscription in subscriptions"
            :key="subscription.id"
            class="col-12 col-sm-6 col-md-6 q-pb-md"
          >
            <q-card class="q-px-md">
              <q-card-section>
                <!-- Title and icon -->
                <q-item class="q-pa-none">
                  <q-item-section>
                    <q-item-label class="flex items-center">
                      <span class="text-h6 text-bold q-mr-sm">
                        {{ subscription.title }}
                      </span>

                      <q-chip
                        outline
                        color="primary"
                        size="12px"
                      >
                        {{ subscription.billing_interval_label }}
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section side>
                    <q-chip
                      size="12px"
                      :color="subscription_status_chip_color(subscription.status).color"
                      :text-color="subscription_status_chip_color(subscription.status).text_color"
                    >
                      {{ subscription.status_label }}
                    </q-chip>
                  </q-item-section>
                </q-item>

                <!-- details -->
                <q-item class="q-pa-none q-pt-none">
                  <q-item-section>
                    <q-item-label class="flex items-center">
                      <span class="text-bold">
                        {{ subscription.price }}

                        <span class="text-muted">{{ subscription.price_per_interval }}</span>
                      </span>
                    </q-item-label>

                    <q-item-label class="">
                      {{ subscription.status_description }}
                    </q-item-label>
                  </q-item-section>
                </q-item>

                <!-- Workspace -->
                <q-item
                  v-if="subscription.workspace_id"
                  class="q-pa-none q-pt-md"
                >
                  <q-item-section>
                    <q-item-label
                      caption
                      class="text-muted"
                    >
                      {{ $page.props.i18n.used_by }}
                    </q-item-label>

                    <q-item-label class="text-bold">
                      <q-avatar
                        round
                        color="transparent"
                        size="22px"
                        style="margin: none"
                      >
                        <Jdenticon
                          :text="subscription.workspace_id"
                          :size="16"
                        />
                      </q-avatar>
                      {{ subscription.workspace_name }}
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-card-section>

              <q-separator />

              <q-card-section v-if="subscription.stripe_id">
                <span
                  class="link-style text-primary"
                  @click="subscription_renew_toggle(subscription)"
                >{{ subscription.renewal_action }}</span>
              </q-card-section>
              <q-inner-loading :showing="subscription.loading">
                <q-spinner-tail
                  color="primary"
                  size="lg"
                />
              </q-inner-loading>
            </q-card>
          </div>

          <div
            v-if="subscriptions.length == 0"
            class="text-center"
          >
            <p class="text-bold q-mt-md">
              {{ $page.props.i18n.no_subscriptions }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
<script>
import Layout from '@/layouts/wide.vue';
import Jdenticon from '@/shared/jdenticon.vue';

export default {
  components: {
    Jdenticon,
    Layout,
  },
  props: {
    subscriptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    subscription_renew_toggle: function(sub) {
      let end_of_period = "cancel";
      if (sub.renewal) {
        end_of_period = "cancel";
      } else {
        end_of_period = "renew";
      }

      this.$inertia.put(
        `./subscriptions/${sub.id}`,
        {
          end_of_period: end_of_period,
        },
        {
          preserveState: true,
          preserveScroll: true,
          onStart: () => {
          },
          onSuccess: () => {
            this.$q.notify({
              message: this.$page.props.flash.success,
              type: "positive",
            });
          },
          onError: (errors) => {
            console.log(errors);
            this.$q.notify({
              message: this.$page.props.flash.alert,
              type: "negative",
            });
          },
          onFinish: () => {
          },
        }
      );
    },
    subscription_status_chip_color: function(status) {
      switch(status) {
      case 'active':
        return { color: "pastel-green", text_color: "black" };
      case 'paused':
        return { color: "pastel-orange", text_color: "black" };
      case 'canceled':
        return { color: "pastel-red", text_color: "black" };
      case 'unpaid':
        return { color: "black", text_color: "white" };
      case 'past_due':
        return { color: "red", text_color: "white" };
      case 'incomplete':
        return { color: "accent", text_color: "white" };
      case 'incomplete_expired':
        return { color: "secondary", text_color: "white" };
      case 'trialing':
        return { color: "pastel-blue", text_color: "black" };
      default:
        return { color: "black", text_color: "white" };
      }
    },
  }
};
</script>
